// Factories State

export default {
  factoriesList: [],
  factoryInfo: {},
  fullFactoriesList: []
}
